import axios from "axios";
import { API_URL } from "../index";

// FE-84: Services.js'ten taşındı (32 uç). Metotlar Services nesnesinde birleşir; this.X çağrıları çalışır.
const servisDepo = {
  AdminOverviewWarehouses(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/admin-overview-warehouses`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: {},
    });
  },

  AssignMerchantToWarehouseCompany(token, userID, corporationID, companyTitle, role) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-profile`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        corporationID,
        companyTitle,
        role
      },
    });
  },

  UpdateWarehouseCompanyUser(token, userID, name, lastname, email, phone, countryCode, corporationID, companyTitle, role, tckn) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-profile`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        name,
        lastname,
        email,
        phone,
        countryCode,
        corporationID,
        companyTitle,
        role,
        tckn
      },
    });
  },

  UnassignMerchantFromWarehouseCompany(token, userID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-user-profile`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        userID,
        corporationID: "",
        companyTitle: "",
        role: ""
      },
    });
  },

  GetWarehouseCompaniesList(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouse-companies`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        withAllFeatures: true
      }
    });
  },

  CreateWarehouseCompany(token, title, registrationTitle, taxNo, taxAdministration, address, neighbourhood, town, city, phone, country, email, countryCode, website, logo, type) {
    return axios({
      method: "post",
      url: `${API_URL}flow/create-warehouse-company`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title,
        registrationTitle,
        taxNo,
        taxAdministration,
        address,
        neighbourhood,
        town,
        city,
        phone,
        country,
        email,
        countryCode,
        website,
        logo,
        type
      }
    });
  },

  UpdateWarehouseCompany(token, companyID, title, registrationTitle, taxNo, taxAdministration, address, neighbourhood, town, city, phone, country, email, countryCode, website, logo, type) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-warehouse-company`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        title,
        registrationTitle,
        taxNo,
        taxAdministration,
        address,
        neighbourhood,
        town,
        city,
        phone,
        country,
        email,
        countryCode,
        website,
        logo,
        type
      }
    });
  },

  RemoveWarehouseCompany(token, companyID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-warehouse-company`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID
      }
    });
  },

  UploadWarehouseCompanyDocument(token, companyID, document, type) {
    return axios({
      method: "post",
      url: `${API_URL}flow/upload-warehouse-company-document`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        document,
        type
      }
    });
  },

  AddWarehouseCompanyBankAccount(token, companyID, accountInformation) {
    return axios({
      method: "post",
      url: `${API_URL}flow/add-warehouse-company-bank-account`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        accountInformation
      }
    });
  },

  UpdateWarehouseCompanyBankAccount(token, companyID, bankAccountID, accountInformation) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-warehouse-company-bank-account`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        bankAccountID,
        accountInformation
      }
    });
  },

  RemoveWarehouseCompanyBankAccount(token, companyID, bankAccountID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-warehouse-company-bank-account`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID,
        bankAccountID
      }
    });
  },

  CreateWarehouse(token, title, description, type, companyID, responsibleName, responsibleLastname, neighbourhood, town, city, phone, country, features, countryCode, address, images, workHours, withPadlock, status, coverImage) {

    return axios({
      method: "post",
      url: `${API_URL}flow/create-warehouse`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        title,
        description,
        type,
        companyID,
        responsibleName,
        responsibleLastname,
        neighbourhood,
        town,
        city,
        responsiblePhone: phone,
        country,
        features,
        countryCode,
        address,
        images,
        workHours,
        withPadlock,
        ...(status !== undefined && status !== null ? { status } : {}),
        // coverImage === null → "kapak KALDIRILDI" demektir ve backend'e boş değer olarak
        // iletilmelidir; alanı tamamen atlamak silme bilgisini yok ediyordu.
        ...(coverImage === undefined ? {} : { coverImage: coverImage === null ? "" : coverImage })
      }
    });
  },

  UpdateWarehouse(token, warehouseID, title, description, type, companyID, responsibleName, responsibleLastname, neighbourhood, town, city, phone, country, features, countryCode, address, images, workHours, withPadlock, status, coverImage) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-warehouse`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        warehouseID,
        title,
        description,
        type,
        companyID,
        responsibleName,
        responsibleLastname,
        neighbourhood,
        town,
        city,
        responsiblePhone: phone,
        country,
        features,
        countryCode,
        address,
        images,
        workHours,
        withPadlock,
        ...(status !== undefined && status !== null ? { status } : {}),
        // coverImage === null → "kapak KALDIRILDI" demektir ve backend'e boş değer olarak
        // iletilmelidir; alanı tamamen atlamak silme bilgisini yok ediyordu.
        ...(coverImage === undefined ? {} : { coverImage: coverImage === null ? "" : coverImage })
      }
    });
  },

  RemoveWarehouseImage(token, imageID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/remove-warehouse-image`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        imageID,
      }
    });
  },

  RemoveWarehouse(token, warehouseID) {

    return axios({
      method: "post",
      url: `${API_URL}flow/remove-warehouse`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        warehouseID
      }
    });
  },

  GetWarehouseCompanyDocuments(token, companyID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouse-company-documents`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID
      }
    });
  },

  // Kaydı silmez; status=0 yapıp kaldıran kişi/IP/zaman izini bırakır.
  // ODA YETKİLENDİRME DAVETİ (06.10.2026, BE stage+prod). Kişinin kullandığı 3 uç KİMLİK İSTEMEZ:
  // e-postadaki tahmin edilemez invitationID yetki yerine geçer; token yine gerekir (GetToken ile alınır).
  // Onay yeni hesapta geçici şifre üretir ve "giriş bilgileri" maili ATAR (şablon açıksa).
  GetWarehouseInvitation(token, invitationID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouse-invitation`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { invitationID: String(invitationID || "") },
    });
  },
  ApproveWarehouseInvitation(token, invitationID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/approve-warehouse-invitation`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { invitationID: String(invitationID || "") },
    });
  },
  RejectWarehouseInvitation(token, invitationID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/reject-warehouse-invitation`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { invitationID: String(invitationID || "") },
    });
  },
  // Oda sahibinin (ya da adminin) davet listesi — sonuçları (bekliyor/onaylandı/reddedildi) görmek için.
  GetWarehouseInvitations(token, { snapshotID = "", status = "", limit = 100, offset = 0 } = {}) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouse-invitations`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { snapshotID, status, limit, offset },
    });
  },

  GetWarehouseCompanyBankAccounts(token, companyID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouse-company-bank-accounts`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID
      }
    });
  },

  GetWarehouseList(token) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouses`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
  },

  AddMassWarehouseRooms(token, rooms) {
    return axios({
      method: "post",
      url: `${API_URL}flow/add-mass-warehouse-rooms`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        rooms,
      },
    });
  },

  AddWarehouseRoom(token, companyID, warehouseID, roomSize, roomNo, width, height, length, area, volume, price, comparePrice, currency, insurancePrice, includeTax, inventoryCount, isAvailable) {
    const hasComparePrice =
      comparePrice !== undefined &&
      comparePrice !== null &&
      !(typeof comparePrice === "string" && comparePrice.trim() === "");

    let serviceData = {
      companyID,
      warehouseID,
      roomSize,
      roomNo,
      area,
      volume,
      price,
      currency,
      insurancePrice,
      includeTax,
      inventoryCount,
      isAvailable
    }

    if (hasComparePrice) {
      serviceData.comparePrice = comparePrice
    }

    if (width && length && height) {
      serviceData.width = width
      serviceData.height = height
      serviceData.length = length
    }
    return axios({
      method: "post",
      url: `${API_URL}flow/add-warehouse-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: serviceData
    });
  },

  UpdateWarehouseRoom(token, roomID, companyID, warehouseID, roomSize, roomNo, width, height, length, area, volume, price, comparePrice, currency, insurancePrice, includeTax, inventoryCount, isAvailable) {
    const hasComparePrice =
      comparePrice !== undefined &&
      comparePrice !== null &&
      !(typeof comparePrice === "string" && comparePrice.trim() === "");
    const serviceData = {
      roomID,
      companyID,
      warehouseID,
      roomSize,
      roomNo,
      width,
      height,
      length,
      area,
      volume,
      price,
      currency,
      insurancePrice,
      includeTax,
      inventoryCount,
      isAvailable
    }

    if (hasComparePrice) {
      serviceData.comparePrice = comparePrice
    }
    else {
      serviceData.comparePrice = ""
    }
    return axios({
      method: "post",
      url: `${API_URL}flow/update-warehouse-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: serviceData
    });
  },

  RemoveWarehouseRoom(token, roomID, companyID, warehouseID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/update-warehouse-room`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        roomID,
        companyID,
        warehouseID,
        status: "3"
      }
    });
  },

  GetWarehouseRooms(token, warehouseID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouses-rooms`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        warehouseID
      }
    });
  },

  GetWarehouseCompany(token, companyID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouse-company`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        withAllFeatures: true,
        companyID
      }
    });
  },

  GetWarehouseCompanyUsers(token, companyID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouse-companys-users`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        companyID
      }
    });
  },
  GetWarehouseById(token, warehouseID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouses`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { warehouseID },
    });
  },
  GetWarehouseRoomById(token, roomID) {
    return axios({
      method: "post",
      url: `${API_URL}flow/get-warehouses-room`,
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      data: { roomID },
    });
  },
};

export default servisDepo;
